module.exports = __webpack_public_path__ + "static/img/preview-05.41a95ed8.webp";